import React from 'react';
import { StepsContainer } from './styled';

const StepsWrapper = ({ children, isVisible }) =>
  <StepsContainer isVisible={isVisible}>{children}</StepsContainer>;

export default StepsWrapper;



// WEBPACK FOOTER //
// ./src/components/Auth0Animation/components/StepsWrapper/StepsWrapper.js